/* eslint-disable react/no-unstable-nested-components */
import { SnackbarProvider } from "notistack"
import { ReactElement } from "react"
import { ErrorBoundary } from "react-error-boundary"

import AccountSetUpDialog from "./components/account/accountSetUpDialog"
import AppBar from "./components/appBar/appBar"
import CustomSetupTOTP from "./components/appBar/customSetupTOTP"
import SnackbarDismiss from "./components/buttons/snackbarDismiss"
import AppErrorBoundary from "./components/fallback/appErrorBoundary"
import NavigationWrapper from "./components/navigation/navigationWrapper"
import PreferencesSidebar from "./components/preferences/preferencesSidebar"
import { useScreenSize } from "./hooks/useScreenSize"
import AppRouter from "./router/appRouter"
import { ContentBox, RootFrame } from "./webpageFrame/contentFrames"

/**
 * Parent node for Doc application. All functionality
 * should be contained under this node.
 *
 * @example
 * <App />
 */
const App = (): ReactElement => {
    const { isTabletOrMob } = useScreenSize()

    return (
        <RootFrame>
            <ErrorBoundary FallbackComponent={AppErrorBoundary}>
                <AppBar />
                <NavigationWrapper>
                    <ContentBox>
                        <AppRouter />
                    </ContentBox>
                </NavigationWrapper>

                <PreferencesSidebar />
                <SnackbarProvider
                    maxSnack={4}
                    preventDuplicate
                    autoHideDuration={6000}
                    hideIconVariant
                    action={(snackbarId) => (
                        <SnackbarDismiss snackbarId={snackbarId} />
                    )}
                    anchorOrigin={{
                        vertical: isTabletOrMob ? "top" : "bottom",
                        horizontal: isTabletOrMob ? "center" : "left",
                    }}
                />
                <AccountSetUpDialog />
                <CustomSetupTOTP />
            </ErrorBoundary>
        </RootFrame>
    )
}

export default App
